export const signalColors = {
  playerBackground: "#0E141B",
  playerText: "#F5F7FA",
  colorInputFallback: "#000000",
} as const;
